import Assets from "./assets.vue";
import Description from "./description.vue";
import Options from "./options.vue";
import Variations from "./variations.vue";
import type { Component } from "vue";

// Innovadis custom
import InnoProperties from "./innovadis/inno-properties.vue";

const templateBlocks: { [key: string]: Component } = {
  "product-assets": Assets,
  "product-description": Description,
  "product-options": Options,
  "product-properties": InnoProperties,
  "product-variations": Variations,
};

export default templateBlocks;
